import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { sanitizePartnerOrgLeadContactChannel } from "@shared/helpers/partner-organization-lead-contact";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import type { VolunteerOrganizationLead } from "./entity";

export const VolunteerOrganizationLeadEntityConfig: HyperEntityConfig<VolunteerOrganizationLead> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;
      filter(Roles.AdminsAndManager, true);
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    saving(entity) {
      entity.name = entity.name?.trim() ?? "";
      if (!entity.name) {
        throw new Error("שם הארגון חובה");
      }
      const handlingManagerId = entity.handlingManagerId?.trim() ?? "";
      if (!handlingManagerId) {
        throw new Error("מנהל מלווה חובה");
      }
      entity.handlingManagerId = handlingManagerId;
      const channel = sanitizePartnerOrgLeadContactChannel(entity.contactChannel);
      if (!channel) {
        throw new Error("דרך יצירת קשר חובה");
      }
      entity.contactChannel = channel;
      const phoneNumber = entity.phoneNumber?.trim() ?? "";
      (entity as { phoneNumber: string | null }).phoneNumber = phoneNumber
        ? phoneNumber
        : null;
      if (!entity.volunteerOrganizationId?.trim()) {
        (entity as { volunteerOrganizationId: string | null }).volunteerOrganizationId =
          null;
      }
      const notes = entity.notes?.trim() ?? "";
      (entity as { notes: string | null }).notes = notes || null;
    },
  };
